import VueCookies from 'vue-cookies'

const loadCurretUser = () => {
  return JSON.parse(localStorage.getItem('currentUser')) || VueCookies.get('currentUser') || null
}

const setUserCookie = (user, keepAlive) => {
  if (keepAlive) {
    localStorage.setItem('currentUser', JSON.stringify(user))
  } else {
    VueCookies.set('currentUser', JSON.stringify(user), 0)
  }
}

const clearUserCookie = (keepAlive) => {
  if (keepAlive) {
    localStorage.removeItem('currentUser')
  } else {
    VueCookies.remove('currentUser')
  }
}

const checkErrorResponse = (error) => {
  const response = error.response ? error.response.statusText : error.message
  return response
}

export { loadCurretUser, checkErrorResponse, setUserCookie, clearUserCookie }
